import { mockCustomerDetails } from '@domgen/dgx-fe-common';
import { WorldpayFormField } from '../../models/worldpay/worldpay-form-field.enum';
import { WorldpayFormValue } from '../../models/worldpay/worldpay-form-value.type';

export const mockWorldpayFormValue: WorldpayFormValue = {
  [WorldpayFormField.Address]: mockCustomerDetails.address,
  [WorldpayFormField.BillingAddress]: {
    ...mockCustomerDetails.address,
    sameAsAddress: false,
  },
  [WorldpayFormField.PaperlessPreference]: null,
  [WorldpayFormField.TermsAndConditions]: true,
};
